import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import HekatePlayer from './HekatePlayer';
window.mountHekatePlayer = function mountHekatePlayer(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('HekatePlayer: container not found:', containerId);
        return {
            type: 'video',
            unmount: () => { },
            rerender: () => { },
            get api() { return null; },
        };
    }
    // Determine media type from prop or element tag
    let mediaType = 'video';
    if (props.mediaType) {
        mediaType = props.mediaType;
    }
    else if (props.mediaElementId) {
        const el = document.getElementById(props.mediaElementId);
        if (el && el.tagName === 'AUDIO')
            mediaType = 'audio';
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(HekatePlayer, { ...props, ref: apiRef }));
    return {
        type: mediaType,
        unmount: () => root.unmount(),
        rerender: (newProps) => {
            root.render(React.createElement(HekatePlayer, { ...newProps, ref: apiRef }));
        },
        get api() { return apiRef.current; },
    };
};
